import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import Header from '../presenters/Header';

const Container = styled.div`
  height: 100%;
  min-height: 1px;
  max-height: 100%;
  flex-grow: 1;

  display: flex;
  flex-direction: column;
`;

const ContentContainer = styled.div<{ $show: boolean }>`
  min-height: 1px;
  flex-grow: 1;

  display: ${p => p.$show ? 'flex' : 'none'};
  flex-direction: column;

  > * {
    min-height: 1px;
    flex: 1 1 auto;
  }
`;

export interface MainLayoutProps {
  expanded?: boolean;
  onExpandedChangeRequested?(expanded: boolean): void;
  content: ReactNode;
}

export default function MainLayout({ expanded, onExpandedChangeRequested, content }: MainLayoutProps): ReactElement {

  return (
    <Container id="buzzeasy-CustomerDataFragment">
      {expanded !== undefined && <Header expanded={expanded} onExpandedChangeRequested={onExpandedChangeRequested} />}
      <ContentContainer $show={expanded !== false}>
        {content}
      </ContentContainer>
    </Container>
  );
}